import siteConfig from './siteConfig.js'
import crypto from 'crypto-js'

let _AESKey256 = Array.apply(null, Array(32)).map(() => Math.round(Math.random() * 255)),
    _key_Int = new Int8Array(_AESKey256);

let $_Int8parse = (u8arr) => {
        let len = u8arr.length,
            words = []

        for (var i = 0; i < len; i++) {
            words[i >>> 2] |= (u8arr[i] & 0xff) << (24 - (i % 4) * 8);
        }

        return crypto.lib.WordArray.create(words, len);
    },
    $_byteArrayToHexString = (byteArray) => {
        return Array.from(byteArray, (byte) => {
            return ('0' + (byte & 0xFF).toString(16)).slice(-2)
        }).join('')
    }

let _ivBytes = $_Int8parse(new Int8Array([ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5 ])),
    _AESHexKey = $_byteArrayToHexString(_AESKey256);

let $_AESDecryptMessage = (message) => {
        let _keyBytes = $_Int8parse(_key_Int),
            $encryptedHexStr = crypto.enc.Hex.parse(message),
            _srcs = crypto.enc.Base64.stringify($encryptedHexStr),
            decrypt = crypto.AES.decrypt(_srcs, _keyBytes, {
                iv: _ivBytes,
                mode: crypto.mode.CTR,
                padding: crypto.pad.NoPadding,
            }),
            _decryptedStr = decrypt.toString(crypto.enc.Utf8)

        return _decryptedStr.toString();
    },
    $_AESEncryptMessage = (message) => {
        let _keyBytes = $_Int8parse(_key_Int),
            _srcs = crypto.enc.Utf8.parse(message),
            $encrypted = crypto.AES.encrypt(_srcs, _keyBytes, {
                iv: _ivBytes,
                mode: crypto.mode.CTR,
                padding: crypto.pad.NoPadding
            });

        return $encrypted.ciphertext.toString().toUpperCase();
    }

export default {
    install: function(Vue, options) {
        Vue.prototype.$talkTool = this;
    },
    encryptVersion: 'FPCIM_V1',
    RSAPublicKey: '-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgpB/NrpZMkOxRmoYOy2E\nXWa4T0y8PAoa/RWO67AUmnPSITOXp/KyBiUwqF3sd8JhmXk0mVP+7qNj/XkiIddk\nOY6fcSaEnNFEbM5OjA6wCe8qd2RKBJ5s10Sl+K/eOaJQUOlazEPeQuymsKx/KkfN\ncO/8o323PIGdwequ4H4gfb89tq5uTRlgdaL7BrOx+zrlgJtVxu1iZAD8dZkGVV4B\nbdfTaF+BiQQU6XlB7tdl8kVqM3lhXxlMH092ifMBAueKoBF32D+1SW2Pt4Dg7Qw5\nSLTJd8CaVQhvDg1H72kaVDB6ZfRHJ/yWstOWLGeM8zK0Tf41GnbbLGAIeKZPnnlV\nWQIDAQAB\n-----END PUBLIC KEY-----',
    AESKey256: _AESKey256,
    AESHexKey: _AESHexKey,
    Int8parse: $_Int8parse,
    byteArrayToHexString: $_byteArrayToHexString,
    AESDecryptMessage: $_AESDecryptMessage,
    AESEncryptMessage: $_AESEncryptMessage,
    getDefaultTalk: function(){

        return {
            aid: 0, //聊聊 id
            accessToken: '', //聊聊 token

            // 以上其他 以下 other
            
            cid: null, //對方的 id
            // avatar: '', //客戶不需要對話中頭像
            
            // 以上 other 以下 user

            account: '',
            // avatar: '', 客戶不需要本身頭像
            disableAppUploadFeatureFlag: false,
            disableWebUploadFeatureFlag: false,
            enableChannelExportFeatureFlag: false,
            enableIOSQuickLookFlag: false,
            enableSpeechesStatisticFeatureFlag: false,
            isAllowShareToOtherApp: false,
            isAllowVideoOverIPService: false,
            isAllowVoIPService: false,
            isCheckVoIPTargetBusyFlag: false,
            name: '',
            systemStatusCheckAPI: '',
            
            // 以上群組往 以下我

            scroll: '', //投放 talk box scroll
            nextSend: '', //creat chinnal 之後要送的訊息
        }
    },
    getAvatar: function(channel) {
        let _avatar = channel.avatar;

        return _avatar? `${siteConfig.talkDomainUrl}/upload/avatarfile/${_avatar}`: 'https://im.fpcetg.com.tw/res/icon/icon_userphoto2.png';
    },
    getLastMsg: function(channel) {
        let _lastmsg = channel.lastmsg,
            _lastType = channel.lastmsgtype;

        switch(_lastType){
            case 2:
                _lastmsg = `${_lastmsg}傳送了照片。`
                break
            case 3:
                _lastmsg = `${_lastmsg}傳送了檔案。`
                break
            case 4:
                _lastmsg = `${_lastmsg}傳送了音訊。`
                break
            case 5:
                _lastmsg = `${_lastmsg}傳送了影片。`
                break
            case 6:
                _lastmsg = `${_lastmsg}傳送了貼圖。`
                break
            case 21:
                _lastmsg = `${_lastmsg}傳送了外部連結。`
                break
            case 22:
                _lastmsg = `${_lastmsg}公開了記事本。`
                break
            case 23:
                _lastmsg = `${_lastmsg}公開了相簿。`
                break
            case 31:
                _lastmsg = `${_lastmsg}傳送了動態表單。`
                break
        }

        return _lastmsg;
    }
}
